<!-- <ng-template #circle>
  <svg
    [attr.viewBox]="viewBox()"
    class="n-circular-progress__indeterminate-circle-graphic"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
  >
    <circle [attr.r]="circleRadius()" cx="50%" cy="50%" />
  </svg>
</ng-template> -->

<div
  class="n-circular-progress__determinate-container"
  aria-hidden="true"
  #determinateSpinner
  [ngbTooltip]="(value | number : '.0-2') + (isPercentageValue ? '%' : '')"
  [disableTooltip]="isValueVisible"
>
  <svg
    [attr.viewBox]="viewBox()"
    class="n-circular-progress__determinate-circle-graphic"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
  >
    <circle
      [attr.r]="circleRadius()"
      [style.stroke-width.%]="circleStrokeWidth()"
      class="n-circular-progress__determinate-circle__track"
      cx="50%"
      cy="50%"
    />
    <circle
      [attr.r]="circleRadius()"
      [style.stroke-dasharray.px]="strokeCircumference()"
      [style.stroke-dashoffset.px]="strokeDashOffset()"
      [style.stroke-width.%]="circleStrokeWidth()"
      stroke-linecap="round"
      class="n-circular-progress__determinate-circle__indicator"
      cx="50%"
      cy="50%"
    />
  </svg>
  <dl *ngIf="isValueVisible">
    <dt>{{ label }}</dt>
    <dd>{{ value | number : '.0-2' }}<ng-container *ngIf="isPercentageValue">%</ng-container></dd>
  </dl>
</div>

<!--TODO: figure out why there are 3 separate svgs-->
<!-- <div class="n-circular-progress__indeterminate-container" aria-hidden="true">
  <div class="n-circular-progress__spinner-layer">
    <div class="n-circular-progress__circle-clipper n-circular-progress__circle-left">
      <ng-container [ngTemplateOutlet]="circle"></ng-container>
    </div>
    <div class="n-circular-progress__gap-patch">
      <ng-container [ngTemplateOutlet]="circle"></ng-container>
    </div>
    <div class="n-circular-progress__circle-clipper n-circular-progress__circle-right">
      <ng-container [ngTemplateOutlet]="circle"></ng-container>
    </div>
  </div>
</div> -->
